/**
 * Created by Kristy Kavvada on 29/11/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('beautyCenters', {
                parent: 'app',
                url: '/beautyCenters',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_BC_VISITOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/beautyCenters/beautyCenters.html',
                        controller: 'BeautyCentersController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('beautyCenterView', {
                abstract: true,
                parent: 'app',
                url: '/beautyCenters/search?id:beautyCenterId',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_BC_VISITOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/beautyCenters/beautyCenterView.html',
                        controller: 'BeautyCenterViewController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
